import { newsStore, useNewsItem } from '../../data/stores/newsStore';
import type { NewsDetailWindowConfig, WindowInstance } from '../../workspace/types';
import { formatTime } from '../../shared/format';

interface NewsDetailWindowProps {
  window: WindowInstance<NewsDetailWindowConfig>;
}

export function NewsDetailWindow({ window }: NewsDetailWindowProps) {
  const item = useNewsItem(window.config.newsId);

  if (!item) {
    return (
      <div className="news-detail window-content news-detail--empty">
        <div className="empty-state">Story is no longer available in the local news cache.</div>
      </div>
    );
  }

  return (
    <article className="news-detail no-window-drag">
      <header className="news-detail__header">
        <div className="news-detail__meta">
          <span>{formatTime(item.time)}</span>
          <strong>{item.source}</strong>
          <small>{item.symbols.join(' ')}</small>
        </div>
        <h2>{item.headline}</h2>
        <p>{item.summary}</p>
      </header>
      <section className="news-detail__body">
        {item.body.split('\n').filter(Boolean).map((paragraph, index) => <p key={index}>{paragraph}</p>)}
      </section>
      <footer className="news-detail__footer">
        <button className="button button--secondary" onClick={() => newsStore.markRead(item.id, !item.read)}>
          Mark {item.read ? 'unread' : 'read'}
        </button>
      </footer>
    </article>
  );
}
